import styled from 'styled-components'

const ComponentStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.secondaries.opacity30};

  .global-page-wrapper {
    padding: 0px 0;
  }
`

export default ComponentStyled
